import Vue from 'vue'
import GmapCustomMarker from 'vue2-gmap-custom-marker';

Vue.component('gmap-custom-marker', GmapCustomMarker)
